import React, { useEffect, useState } from "react";
import axios from "axios";
import BlogOverview from "./BlogOverview";
import { Grid, Box, Fade, Typography, makeStyles } from "@material-ui/core/";
import Seo from "../components/Seo";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({}));
const Blog = ({ blog }) => {
  const { t } = useTranslation();

  return (
    <Fade in={true} {...(true ? { timeout: 1000 } : {})}>
      <Grid container noValidate alignItems="stretch">
        <Seo
          title={t("seo.blog.title")}
          description={t("seo.blog.description")}
          pathSlug={t("/blog")}
          keywords=""
        />

        <Grid item xs={12} sm={12}>
          <Box className="boxContainer  blog-overview large stretch">
            <Typography variant="h1" align="center">
              {t("blog.title")}
            </Typography>
            <Typography variant="body1" align="center" color="initial">
              {t("blog.intro")}
            </Typography>
            <Box py={5}>
              <BlogOverview spacing={2} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default Blog;
